<template>
  <div>
    <!--头部-->
    <Header :showValue="2"></Header>
    <!--banner end-->
    <div class="jqgk" style="background: rgba(227, 227, 227, 0.84)">
      <div class="contai" style="max-width: 1197px;background:white;padding-left:40px;padding-right:40px;margin-bottom: 40px">
        <div class="top_tit" style="margin-top: 0px">
          <!-- <span class="titleFont">景点介绍</span> -->
          <div style="height:25px" v-if="pcshow"></div>
          <div class="titleShuXian" v-if="pcshow"></div>
          <span class="titleFont" v-if="pcshow">{{china}}</span>
          <span class="titleFontEnglish" v-if="pcshow">{{english}}</span>

          <div class="titleShuXianForPhone" v-if="!pcshow"></div>
          <span class="titleFont" style="font-size:16px" v-if="!pcshow">{{china}}</span>
          <span class="titleFontEnglishForPhone" style="font-size:12px" v-if="!pcshow">{{english}}</span>
          <div style="height: 1px; width: 100%"></div>
          <div style="text-align: left; margin: 0px">
            <div class="travel_con">
              <div class="">
                <!-- 图片显示 -->
                <el-row  v-if="pcshow" style="margin-right: 0px; margin-top: 105px">
                  <div v-for="item in dataList" :key="item.id">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                      <a>
                        <div

                          class="showPicturePC"
                          @click="seeInfo(item)"
                        >
                          <img
                            :src="item.url"
                            alt="...."
                            class="sceneryImgSize"
                          />
                          <div class="sceneryFontSize">{{ item.title }}</div>
                          <!-- <span class="sceneryDescFontSize">{{
                            item.introduce
                          }}</span> -->
                          <div class="rownew">
                            <div class="sceneryDescFontSize33">  {{  item.introduce  }}  </div>
                            <div style=" line-height: 30px;color:blue" @click="seeInfo(item)">详情</div>
                          </div>

                        </div>
                      </a>
                    </el-col>
                  </div>
                  </el-row>

                  <el-row v-if="!pcshow" style="margin-right: 0px; margin-top: 85px">
                    <!--  手机端 -->
                    <div >
                      <div v-for="item in dataList" :key="item.id">
                        <div class="showPicture">
                          <img :src="item.url" alt="...." />
                          <div class="sceneryFontSize">{{ item.title }}</div>
                          <span class="mobileSceneryDescFontSizeForO">{{
                            item.introduce
                          }}</span>
                          <div style="text-align:right">
                          <button
                            class="mobileSceneryBtnFor"
                            @click="seeInfo(item)"
                          >
                            更多
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getZDRYFBList, getZJXQSList } from '@/api/public'
import Header from './header'
import Footer from './footer'

export default {
  components: { Header, Footer },
  data () {
    return {
      china: '',
      english: '',
      choseValue: 1,
      pcshow: false,
      styletable: { background: '#F2DCCA' },
      mapStyle: { background: '#E6E6E6' },
      dataList: []
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },
  mounted () {
    this.initJDJSList()
  },

  methods: {
    // 属性排序sort
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    initJDJSList () {
      var that = this
      getZDRYFBList().then(response => {
        var list = response.data
        this.dataList = list.sort(this.compare('sort'))
      })

      getZJXQSList().then(response => {
        this.china = response.data.sort(this.compare('sort'))[1].title
        this.english = response.data.sort(this.compare('sort'))[1].enTitle
      })
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 菜单选择
    tabSelect (e) {
      let value = e.target.dataset.index
      this.choseValue = value
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfoForjiesaho',
        query: {
          id: infoid
        }
      })
    }
  }
}
</script>
<style>
.sceneryDescFontSize33 {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  /* padding: 0 20px; */
  margin-bottom: 15px;
  width: 240px;
  /* height: 60px; */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.rownew {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleShuXianForPhone{
  height: 28px;
  margin-top: 14px;
  width: 4px;
  background-color: #840207;
  float: left;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.titleFontEnglishForPhone {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 0px;
}
.tra_tab {
  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFont {
  font-size: 33px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.sceneryImgSize {
  /* width: 542px;
  height: 359px; */
  /* width: 250px; */
  /* padding-right: 5px; */

  height: 200px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.showPicturePC {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  /* margin: 0 10px 30px 0; */
  margin: 0 10px 0px 0;
}
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin: 0 10px 20px 0;
}
.sceneryDescFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mobileSceneryDescFontSizeForO{
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  max-height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin: 25px 0px 50px;
}
.mobileSceneryBtnFor{
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 86px;
  background: #840207;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/scenery.vue